import {FC} from 'react';

import {Close} from '@mui/icons-material';
import {Box, IconButton, SxProps, Typography} from '@mui/material';

import {greenColors, orangeColors} from '../../layouts/theme/designSystem';

interface EmpionLabeledValueProps {
  label: string;
  value?: string;
  color?: 'primary' | 'secondary';
  light?: boolean;
  sx?: SxProps;
  onDelete?: () => void;
}

const EmpionLabeledValue: FC<EmpionLabeledValueProps> = ({label, value, sx, color, light, onDelete}) => {
  const backgroundColor = (() => {
    if (light) {
      return orangeColors[3];
    }
    return orangeColors[3];
  })();
  const textColors = (() => {
    if (color === 'secondary') {
      return {
        label: orangeColors[900],
        value: orangeColors[70],
      };
    }
    return {
      label: greenColors[700],
      value: greenColors[70],
    };
  })();

  return (
    <Box
      sx={{
        backgroundColor,
        display: 'flex',
        width: '100%',
        padding: '4px 16px',
        borderRadius: '2px',
        ...sx,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 1,
          width: '100%',
          minWidth: 0,
        }}
      >
        <Typography color={textColors.label} variant='body1' sx={{minWidth: 0, overflowWrap: 'anywhere'}}>
          {label}
        </Typography>
        {value && (
          <Typography color={textColors.value} variant='body1' sx={{flexShrink: 0, whiteSpace: 'nowrap'}}>
            {value}
          </Typography>
        )}
        {!!onDelete && (
          <IconButton
            onClick={onDelete}
            sx={{
              color: orangeColors[900],
            }}
            aria-label='Delete'
            data-testid={label + '-labeled-value-delete'}
          >
            <Close
              sx={{
                fontSize: '16px',
              }}
            />
          </IconButton>
        )}
      </Box>
    </Box>
  );
};

export default EmpionLabeledValue;
